import GeneratedMessageServiceApi from "./generated/GeneratedMessageServiceApi"

class MessageServiceApi extends GeneratedMessageServiceApi {

}

export const messageServiceApi = new MessageServiceApi()
